import ReactSelect from 'react-select';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { dropDownStyles } from './Header.styled';
import { useContext } from 'react';
import { LanguageContext } from '../../providers/LanguageProvider';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { setSelectedLanguageAction } from '../../store/SelectedLanguage/action';

export function LanguageSelect() {
  const languages = useAppSelector((st) => st.selectedLang.languages);
  const pathname = usePathname();
  const languageContext = useContext(LanguageContext);
  const searchParams = useSearchParams();
  const router = useRouter();
  const dispatch = useAppDispatch();

  return (
    <ReactSelect
      className='custom-select language-select'
      options={languages}
      value={languages.find((item) => item.id.toLowerCase() === languageContext.lang.toLowerCase())}
      styles={dropDownStyles}
      isClearable={false}
      isSearchable={false}
      instanceId={'language-select'}
      classNamePrefix='react-select'
      aria-label='Select language'
      onChange={(option: any) => {
        if (!option) return;

        // Extract the new language
        const newLang = option?.id.toLowerCase();

        // Check if the current path includes a language segment
        const newPath = pathname.match(/^\/[a-z]{2}(\/|$)/)
          ? pathname.replace(/^\/[a-z]{2}(\/|$)/, `/${newLang}$1`)
          : `/${newLang}${pathname}`;

        // Preserve query parameters
        const queryString = searchParams.toString();
        const fullPath = queryString ? `${newPath}?${queryString}` : newPath;

        // Navigate to the new path
        router.replace(fullPath);

        dispatch(setSelectedLanguageAction(newLang));
      }}
      theme={(theme) => {
        return {
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            text: 'white',
            primary: 'black',
          },
        };
      }}
    />
  );
}
